/* global Phaser */

import * as setup from '@/setup';
import runtime from '@/runtime';

/**
 * Segni di punteggiatura e separatori usati nel ditloide
 * Centralizzato per evitare duplicazione e mantenere consistenza
 */
const PUNCTUATION_CHARS = '.,/:;\'?!"()&+-';
const PUNCTUATION_REGEX = new RegExp(`[${PUNCTUATION_CHARS.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}]`, 'g');
const PUNCTUATION_REGEX_WITH_SPACE = new RegExp(`[ ${PUNCTUATION_CHARS.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}]`, 'g');
const SPLIT_REGEX = new RegExp(`(\\s*[ ${PUNCTUATION_CHARS.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}]\\s*)`, 'g');
// Regex per identificare token composti solo da punteggiatura (es: "(", ")", ",", etc.)
const PUNCTUATION_ONLY_REGEX = new RegExp(`^[${PUNCTUATION_CHARS.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}]+$`);
var createDitloide = (solution) => {
	let ditloide = '';
	// sostituisco ai segni di interpunzione
	//let string = solution.replace(/(\s*[.,\/:';+\?\!#\"\&\(\)-]\s*)/g, ' ' + '$1' + ' ');
	let solutionSplit = solution.split(SPLIT_REGEX);
	for (let word of solutionSplit) {
		// skippo le parole vuote, frutto di residuati di spazi
		if (word === "") {
			continue;
		}

		// I token composti solo da punteggiatura (es: "(", ")", ",", etc.)
		// vengono aggiunti al ditloide così come sono, come fossero articoli
		if (PUNCTUATION_ONLY_REGEX.test(word.trim())) {
			ditloide = ditloide.concat(word);
			continue;
		}

		// 0° - controllo se la parola è composta SOLO da numeri
		// Le parole composte solo da numeri vanno trattate come preposizioni e visualizzate intere
		const onlyNumbersRegex = /^\d+$/;
		if (onlyNumbersRegex.test(word)) {
			ditloide = ditloide.concat(word + ' ');
			continue;
		}

		//1 ° - controllo la presenza di numeri
		var matches = numberIsPresent(word);
		if (matches !== null) {
			//il numero e presente nella parola creo quindi l'apposito ditloide
			var ditNumber = ditloideCaseNumber(matches, word);
			ditloide = ditloide.concat(ditNumber + ' ');
		} else {
			//2 ° - controlla se la parola e presente nella lista delle visualizzabili
			var indx = visibleWordIsPresent(word);
			var ditVisiWord = ditloideCaseVisibleWord(indx, word);
			ditloide = ditloide.concat(ditVisiWord);
		}
	}
	return ditloide;
};

/************************************************************/
/******************Creazione del ditloide********************/
/************************************************************/
//controllo la presenza di un valore numerico nella parola
var numberIsPresent = (word) => {
	const allNumRegex = /\d+/;
	let matches = word.match(allNumRegex);
	return matches;
};

/************************************************
 *
 * //creazione di un ditloide da una parola con numero
 *
 *************************************************/
var ditloideCaseNumber = (matches, word) => {
	let numberDitloide = '';
	let numIndex = numberIndex(matches);
	if (numIndex > 0) {
		//il numero è posizionato non all'inizio della stringa copio quindi la prima lettera e il numero
		numberDitloide = word[0].toUpperCase() + matches[0];
	} else {
		//il numero è all'inizio della parola quindi salviamo solo quello
		numberDitloide = matches[0];
	}
	return numberDitloide;
};

/************************************************
 *
 * //creazione di un ditloide, dopo il controllo delle parole da visualizzare
 *
 *************************************************/
var ditloideCaseVisibleWord = (indx, word) => {
	let wordDitloide = '';
	if (indx != -1) {
		wordDitloide = word;
	} else {
		wordDitloide = word[0].toUpperCase();
	}
	return wordDitloide;
};

//trovo l'indice per individuare la posizione del numerico
var numberIndex = (matches) => {
	let numIndex = matches.index;
	return numIndex;
};
//se presente trovo l'indice della parola nell'array altrimenti avrà -1
var visibleWordIsPresent = (word) => {
	let indx = setup.wordToShow.indexOf(word.toLowerCase());
	return indx;
};

var createLetterOfSolution = (solution) => {
	let mySol = solution.toUpperCase().replace(PUNCTUATION_REGEX_WITH_SPACE, '');
	let arrLett = Phaser.Utils.Array.Shuffle([...new Set(mySol)]);
	return arrLett;
};

/************************************************
 *
 * Crea un array con i caratteri da visualizzare nello schema del ditloide.
 * L'array ha la stessa lunghezza della stringa solution.
 *
 * Per ogni posizione:
 * - Lettera visibile (prima lettera di parola abbreviata o parola intera): carattere originale
 * - Lettera da indovinare: ' ' (spazio)
 * - Spazio tra parole: false (separatore)
 * - Punteggiatura (parentesi, etc.): carattere originale (visibile)
 *
 *************************************************/
var initialWordHelp = (solution, ditloide) => {
	// Divido la soluzione e il ditloide in parole
	let splitSolution = solution.trim().split(PUNCTUATION_REGEX_WITH_SPACE).filter(el => el !== "");
	let splitDitloide = ditloide.trim().split(PUNCTUATION_REGEX_WITH_SPACE).filter(el => el !== "");

	// Creo una mappa parola -> come deve essere visualizzata
	// Per ogni parola della soluzione, determino quali caratteri sono visibili
	let wordVisibilityMap = [];
	for (let i = 0; i < splitSolution.length; i++) {
		let solWord = splitSolution[i];
		let ditWord = splitDitloide[i] || '';
		let visibility = [];

		if (solWord.toLowerCase() === ditWord.toLowerCase()) {
			// Parola intera visibile (articolo, preposizione, etc.)
			for (let c of solWord) {
				visibility.push(c);
			}
		} else {
			// Solo alcune lettere visibili (quelle del ditloide)
			let ditLen = ditWord.length;
			for (let j = 0; j < solWord.length; j++) {
				if (j < ditLen && solWord[j].toLowerCase() === ditWord[j].toLowerCase()) {
					visibility.push(solWord[j]); // Lettera visibile
				} else {
					visibility.push(' '); // Lettera da indovinare
				}
			}
		}
		wordVisibilityMap.push(visibility);
	}

	// Ora itero sulla stringa solution originale carattere per carattere
	let arr = [];
	let wordIndex = 0;  // Indice della parola corrente in splitSolution
	let charIndex = 0;  // Indice del carattere corrente nella parola
	let inWord = false; // Flag per sapere se siamo dentro una parola

	for (let i = 0; i < solution.length; i++) {
		let char = solution[i];

		if (char === ' ') {
			// Spazio: separatore tra parole
			arr.push(false);
			if (inWord) {
				// Fine della parola corrente
				wordIndex++;
				charIndex = 0;
				inWord = false;
			}
		} else if (PUNCTUATION_ONLY_REGEX.test(char)) {
			// Punteggiatura (parentesi, etc.): visibile
			arr.push(char);
			// Se eravamo dentro una parola, la punteggiatura la termina
			// (es: "DOV'È" → l'apostrofo separa "DOV" da "È")
			if (inWord) {
				wordIndex++;
				charIndex = 0;
				inWord = false;
			}
		} else {
			// Lettera: usa la mappa di visibilità
			inWord = true;
			if (wordIndex < wordVisibilityMap.length && charIndex < wordVisibilityMap[wordIndex].length) {
				arr.push(wordVisibilityMap[wordIndex][charIndex]);
				charIndex++;
			} else {
				// Fallback: lettera da indovinare
				arr.push(' ');
			}
		}
	}

	return arr;
};

/************************************************
 *
 * cerca nello schema le sole consonanti/vocali rimaste
 *
 *************************************************/
var hasUnsolvedLetter = (boardBoxes, type) => {
	let targetMap;
	if (type === runtime.constants.superpower.MOTIVE_CONSONANT)
		targetMap = setup.game.score.consonants;
	else if (type === runtime.constants.superpower.MOTIVE_VOWEL)
		targetMap = setup.game.score.vowels;
	else {
		targetMap = new Map([...setup.game.score.consonants, ...setup.game.score.vowels]);
	}
	let unsolvedLetter = [];
	for (let box of boardBoxes) {
		// lettere rimaste insolute
		if (box.input && box.input.enabled === true) {
			//console.log('lettera schema', box.datas);
			// è una lettera vuota da compilare
			if (box.datas.char === ' ' && targetMap.has(box.datas.solution)) {
				unsolvedLetter.push(box.datas.solution);
				//console.log('trovate lettera', box.datas.solution);
			}
		}
	}
	//console.log('Lettere ancora da risolvere', unsolvedLetter);
	// conta le occorrenze delle lettere
	let occRestLetter = unsolvedLetter.reduce(function (prev, next) {
		prev[next] = prev[next] + 1 || 1;
		return prev;
	}, {});

	//console.log('Occorrenze delle Lettere ancora da risolvere', occRestLetter);
	let keysSorted = Object.keys(occRestLetter).sort(function (a, b) {
		return occRestLetter[b] - occRestLetter[a];
	});
	//console.log('Occorrenze delle Lettere ancora da risolvere ordinate descrscenti', keysSorted);

	return keysSorted || false;
};

/************************************************
 *
 * Restituisce gli indici delle lettere mancanti della parola su cui è posizionato il cursore.
 * Se currentIndex è specificato, trova la parola che contiene quella posizione.
 * Se la parola corrente è già completa, cerca la prossima parola incompleta.
 *
 *************************************************/
var findWords = (boardBoxes, currentIndex = null) => {
	// array delle parole incomplete
	let wordsArray = [];
	// array delle parole complete
	let completeWordsArray = [];
	// array degli indici di inizio parola nel boardBoxes
	let wordStartIndexes = [];
	// array degli indici di fine parola nel boardBoxes
	let wordEndIndexes = [];

	// setup parola iniziale
	let word = '';
	let completeWord = true;
	let currentWordStart = -1;
	let boxIndex = 0;

	for (let box of boardBoxes) {
		// nuova parola ha inizio (spazio = false, oppure punteggiatura)
		if (box.datas.char === false || (typeof box.datas.char === 'string' && PUNCTUATION_ONLY_REGEX.test(box.datas.char))) {
			// Salva la parola corrente solo se non è vuota
			if (word.length > 0) {
				wordsArray.push(word);
				wordStartIndexes.push(currentWordStart);
				wordEndIndexes.push(boxIndex - 1);
				if (completeWord === true) {
					// parola completata con successo
					completeWordsArray.push(true);
				} else {
					completeWordsArray.push(false);
				}
				// setup prossima parola
				word = '';
				completeWord = true;
				currentWordStart = -1;
			}
			boxIndex++;
			continue;
		}

		// Se è l'inizio di una nuova parola, salva l'indice
		if (currentWordStart === -1) {
			currentWordStart = boxIndex;
		}

		word += box.datas.char;

		// seleziono solo caratteri e separatori. Se c'è un carattere vuoto prima di un false allora la parola è incompleta
		if (box.datas.char === ' ') {
			completeWord = false;
		}
		boxIndex++;
	}

	// Aggiungi l'ultima parola se non è vuota (per gestire la fine della stringa)
	if (word.length > 0) {
		wordsArray.push(word);
		wordStartIndexes.push(currentWordStart);
		wordEndIndexes.push(boxIndex - 1);
		completeWordsArray.push(completeWord);
	}

	// Se non ci sono parole, ritorna un array vuoto
	if (wordsArray.length === 0) {
		return [];
	}

	// Trova l'indice della parola su cui è posizionato il cursore
	let targetWordIndex = -1;

	if (currentIndex !== null && currentIndex >= 0) {
		// Cerca la parola che contiene la posizione del cursore
		for (let i = 0; i < wordsArray.length; i++) {
			if (currentIndex >= wordStartIndexes[i] && currentIndex <= wordEndIndexes[i]) {
				targetWordIndex = i;
				break;
			}
		}

		// Se la parola corrente è completa, cerca la prossima parola incompleta a partire dalla posizione corrente
		if (targetWordIndex !== -1 && completeWordsArray[targetWordIndex] === true) {
			// Cerca prima dalla parola corrente in avanti
			let foundIncomplete = false;
			for (let i = targetWordIndex; i < wordsArray.length; i++) {
				if (completeWordsArray[i] === false) {
					targetWordIndex = i;
					foundIncomplete = true;
					break;
				}
			}
			// Se non trovata, cerca dall'inizio fino alla posizione corrente
			if (!foundIncomplete) {
				for (let i = 0; i < targetWordIndex; i++) {
					if (completeWordsArray[i] === false) {
						targetWordIndex = i;
						foundIncomplete = true;
						break;
					}
				}
			}
			// Se tutte le parole sono complete, ritorna array vuoto
			if (!foundIncomplete) {
				return [];
			}
		}
	}

	// Fallback: se non è stata trovata una parola valida, cerca la parola incompleta più lunga
	if (targetWordIndex === -1) {
		let mostLength = 0;
		for (let i = 0; i < wordsArray.length; i++) {
			if (completeWordsArray[i] === false && (wordsArray[i].match(/ /g) || []).length > mostLength) {
				mostLength = (wordsArray[i].match(/ /g) || []).length;
				targetWordIndex = i;
			}
		}
	}

	// Se non ci sono parole incomplete, ritorna un array vuoto
	if (targetWordIndex === -1 || wordStartIndexes[targetWordIndex] === undefined) {
		return [];
	}

	let start = wordStartIndexes[targetWordIndex];
	let offset = wordsArray[targetWordIndex].length;
	let arrayWord = [];
	let children = boardBoxes;
	for (let i = start; i < start + offset; i++) {
		let box = children[i];
		if (!box || !box.datas || box.datas.char !== ' ')
			continue;
		arrayWord.push(i);
	}
	return arrayWord;
};

/************************************************
 *
 * cerca lettere da risolvere
 * Se currentIndex è specificato, cerca prima la lettera nella posizione corrente del cursore
 * Se la lettera corrente non è del tipo richiesto, cerca la prossima lettera del tipo richiesto partendo dalla posizione corrente
 *
 *************************************************/
var findLetter = (boardBoxes, type, currentIndex = null) => {
	let targetMap;
	if (type === runtime.constants.superpower.MOTIVE_CONSONANT)
		targetMap = setup.game.score.consonants;
	else if (type === runtime.constants.superpower.MOTIVE_VOWEL)
		targetMap = setup.game.score.vowels;
	else {
		targetMap = new Map([...setup.game.score.consonants, ...setup.game.score.vowels]);
	}
	
	let letter = null;
	
	// Se è specificata la posizione corrente, controlla prima quella
	if (currentIndex !== null && currentIndex >= 0 && currentIndex < boardBoxes.length) {
		let currentBox = boardBoxes[currentIndex];
		// Se la casella corrente è vuota e la lettera è del tipo richiesto, usa quella
		if (currentBox.input && currentBox.input.enabled === true && 
		    currentBox.datas.char === ' ' && 
		    targetMap.has(currentBox.datas.solution)) {
			letter = currentBox.datas.solution;
			console.log('findLetter: trovata lettera nella posizione corrente', letter, 'alla posizione', currentIndex);
		} else {
			// La lettera corrente non è del tipo richiesto, cerca la prossima lettera del tipo richiesto
			// partendo dalla posizione corrente
			console.log('findLetter: lettera corrente non è del tipo richiesto, cerco la prossima. Posizione corrente:', currentIndex, 'Tipo richiesto:', type);
			for (let i = currentIndex; i < boardBoxes.length; i++) {
				let box = boardBoxes[i];
				if (box.input && box.input.enabled === true && 
				    box.datas.char === ' ' && 
				    targetMap.has(box.datas.solution)) {
					letter = box.datas.solution;
					console.log('findLetter: trovata prossima lettera del tipo richiesto', letter, 'alla posizione', i);
					break;
				}
			}
			// Se non trovata, cerca dall'inizio fino alla posizione corrente
			if (!letter) {
				for (let i = 0; i < currentIndex; i++) {
					let box = boardBoxes[i];
					if (box.input && box.input.enabled === true && 
					    box.datas.char === ' ' && 
					    targetMap.has(box.datas.solution)) {
						letter = box.datas.solution;
						console.log('findLetter: trovata lettera cercando dall\'inizio', letter, 'alla posizione', i);
						break;
					}
				}
			}
		}
	}
	
	// Se non abbiamo trovato una lettera, cerca la più frequente (fallback)
	if (!letter) {
		let unsolvedLetter = hasUnsolvedLetter(boardBoxes, type);
		if (!unsolvedLetter)
			return false;
		letter = unsolvedLetter[0];
	}
	
	//console.log('Lettera da scoprire', letter);

	// trovate tutte le occorrenze della lettera e relativo indice
	let arrayLetter = [];
	for (let i = 0; i < boardBoxes.length; i++) {
		let box = boardBoxes[i];
		//console.log(box.datas);
		// lettere rimaste
		if (box.input && box.input.enabled === true && box.datas.solution == letter) {
			//console.log('trovata lettera alla posizione i-esima', letter, i);
			arrayLetter.push(i);
		}
	}
	return arrayLetter;
};

var findBoxLetter = (playerBoxes, letter) => {
	if (!playerBoxes || !playerBoxes.getChildren) {
		return undefined;
	}
	for (let box of playerBoxes.getChildren()) {
		if (letter === box.datas.char) {
			return box;
		}
	}
	return undefined;
};

// Conta le lettere già scoperte sulla schema
var countSchemaLetters = (schemaArray) => {
	let schemaLetters = 0;
	for (let arr of schemaArray) {
		if (arr !== ' ' && arr !== false)
			schemaLetters++;
	}
	return schemaLetters;
};

/************************************************
 *
 * Formatta il ditloide per la visualizzazione del titolo
 * Aggiunge un punto dopo ogni lettera maiuscola singola (non dopo parole complete)
 * Esempio: "TC DELLE S di JG" diventa "T.C. DELLE S. di J.G."
 * Gestisce anche punteggiatura dopo lettere: "V?" diventa "V.?"
 *
 *************************************************/
var formatDitloideTitle = (ditloide) => {
	var formatted = '';
	var chars = ditloide.split('');
	
	for (var i = 0; i < chars.length; i++) {
		var currentChar = chars[i];
		var prevChar = i > 0 ? chars[i - 1] : null;
		var nextChar = i < chars.length - 1 ? chars[i + 1] : null;
		
		// Aggiungi il carattere corrente
		formatted += currentChar;
		
		// Aggiungi punto solo se:
		// 1. Il carattere corrente è una lettera maiuscola
		// 2. Il precedente carattere è uno spazio, null (inizio stringa) O punteggiatura/separatori
		// 3. Il prossimo carattere è uno spazio, null (fine stringa) O punteggiatura
		// Questo garantisce che sia una lettera SINGOLA, non parte di una parola
		// Gestisce anche casi come "V?" -> "V.?" e "M:R" -> "M.:R."
		var isUpperCase = currentChar.match(/[A-Z]/);
		var isPrevSpaceOrPunct = prevChar === ' ' || prevChar === null || (prevChar && PUNCTUATION_REGEX.test(prevChar));
		var isNextSpaceOrPunct = nextChar === ' ' || nextChar === null || (nextChar && PUNCTUATION_REGEX.test(nextChar));
		
		if (isUpperCase && isPrevSpaceOrPunct && isNextSpaceOrPunct) {
			formatted += '.';
		}
	}
	
	return formatted;
};

export {
createDitloide,
	createLetterOfSolution,
	initialWordHelp,
	hasUnsolvedLetter,
	findWords,
	findLetter,
	findBoxLetter,
	countSchemaLetters,
	formatDitloideTitle
};

